import React, { useState, useEffect, useRef, useContext } from "react";
import truncateWallet from "../../utils/truncateWallet";
import { useAccount, useEnsName, useDisconnect } from "wagmi";
import { useAppKit, useAppKitAccount } from "@reown/appkit/react";
import { useDisconnect as useAppKitDisconnect } from "@reown/appkit/react";

import backPng from "../../assets/media/icons/Back.png";
import xPng from "../../assets/media/icons/X.png";
import discordPng from "../../assets/media/icons/Discord.png";
import ecosystemPng from "../../assets/media/icons/Ecosystem.png";
import lockPng from "../../assets/media/icons/Lock.png";
import teamPng from "../../assets/media/icons/Team.png";
import logo from "../../assets/media/icons/ff-logo-new.png";
import starLogo from "../../assets/media/icons/FinalLogoBig-star.png";
import musicOnPng from "../../assets/media/icons/MusicOn.png";
import musicOffPng from "../../assets/media/icons/MusicOff.png";
import walletPng from "../../assets/svg/Wallet.png";
import ethLogoMedium from "../../assets/media/icons/ETH-Logo-Medium.png";
import trophyIcon from "../../assets/icons/trophy-icon.png";
import documentIcon from "../../assets/icons/document-256.png";

import { UserContext } from "../../provider/userprovider";
import StarterInfoModal from "./StarterInfoModal";

import "./NavBar2.scss";

const LANDING_URL = "https://www.fortunefoes.com/allowlist";
const STARTER_INFO_DISMISSED_COOKIE = "pnl_starter_info_dismissed";

const hasCookie = (name) => {
  if (typeof document === "undefined") return false;
  return document.cookie.split("; ").some((entry) => entry.startsWith(`${name}=`));
};

const setCookie = (name, value, maxAgeSeconds) => {
  if (typeof document === "undefined") return;
  document.cookie = `${name}=${value}; path=/; max-age=${maxAgeSeconds}; samesite=lax`;
};

const NavBar2 = () => {
  const [isSoundEnabled, setIsSoundEnabled] = useState(true);
  const [showStarterInfo, setShowStarterInfo] = useState(false);
  const { address, isConnected, status, connector } = useAppKitAccount();
  const isReconnecting = status === "reconnecting";
  const { open } = useAppKit();
  const { data: ensName } = useEnsName({ address });
  const { disconnect: appkitDisconnect } = useAppKitDisconnect();
  const { userInfo, walletConnect, logout } = useContext(UserContext);
  const hasTriedLogin = useRef(false);

  useEffect(() => {
    if (!isConnected) hasTriedLogin.current = false;
  }, [isConnected]);

  useEffect(() => {
    if (!hasCookie(STARTER_INFO_DISMISSED_COOKIE)) {
      setShowStarterInfo(true);
    }
  }, []);

  const closeStarterInfo = () => {
    setCookie(STARTER_INFO_DISMISSED_COOKIE, "1", 60 * 60 * 24 * 365);
    setShowStarterInfo(false);
  };

  const handleConnectWallet = async () => {
    await open();
  };

  const handleLogout = async () => {
    await appkitDisconnect();
    logout();
  };
  useEffect(() => {
    async function fetchData() {
      if (!isConnected || !address) return;

      const existingToken = localStorage.getItem("pnl_token");
      if (existingToken) return; // already logged in

      if (hasTriedLogin.current) return; // prevent double call (StrictMode, re-renders, etc.)
      hasTriedLogin.current = true;

      await walletConnect(address);
    }

    fetchData();
  }, [address, isConnected]);
  return (
    <div className="header-top-wrapper">
      <header className="header">
        <div className="header-left">
          <button
            className="icon-button icon-button--back"
            type="button"
            onClick={() => {
              window.location.href = LANDING_URL;
            }}
            aria-label="Back to landing"
          >
            <img className="icon-img" src={backPng} alt="back" />
          </button>

          <span className="header-divider" aria-hidden="true" />

          <button
            className="icon-button icon-button--mobile-info"
            type="button"
            aria-label="Info"
            onClick={() => setShowStarterInfo(true)}
          >
            <img
              className="icon-img icon-img--document"
              src={documentIcon}
              alt=""
              aria-hidden="true"
            />
            <span className="icon-button-label">INFO</span>
          </button>

          <button
            className="icon-button icon-button--x"
            type="button"
            onClick={() => window.open("https://x.com/fortunefoes", "_blank")}
            aria-label="Open X"
          >
            <img className="icon-img" src={xPng} alt="X" />
          </button>

          <button
            className="icon-button"
            type="button"
            onClick={() => window.open("https://discord.gg/Foes", "_blank")}
            aria-label="Open Discord"
          >
            <img className="icon-img" src={discordPng} alt="Discord" />
          </button>

          <button
            className="icon-button icon-button--league-info"
            type="button"
            aria-label="League info"
            onClick={() => setShowStarterInfo(true)}
          >
            <img
              src={trophyIcon}
              alt="League Info"
              className="tab-icon tab-icon--trophy"
            />
            <span className="icon-button-label">LEAGUE INFO</span>
          </button>

          {/* <button
            className="icon-button"
            type="button"
            onMouseEnter={() => setHoveredEcosystem(true)}
            onMouseLeave={() => setHoveredEcosystem(false)}
            aria-label="Ecosystem coming soon"
          >
            <span
              className="allowlist-icon"
              aria-hidden="true"
              style={{
                position: "absolute",
                opacity: hoveredEcosystem ? 0 : 0.9,
                transition: "opacity 0.7s ease",
                pointerEvents: "none",
              }}
            >
              <img className="icon-img" src={ecosystemPng} alt="Ecosystem" />
            </span>
            <span
              className="lock-icon"
              aria-hidden="true"
              style={{
                position: "relative",
                opacity: hoveredEcosystem ? 0.9 : 0,
                transition: "opacity 0.7s ease",
                pointerEvents: "none",
              }}
            >
              <img className="icon-img" src={lockPng} alt="" />
            </span>
            <span className="icon-button-label">ECOSYSTEM</span>
          </button> */}

          {/* <button
            className="icon-button"
            type="button"
            onMouseEnter={() => setHoveredCaptains(true)}
            onMouseLeave={() => setHoveredCaptains(false)}
            aria-label="Captains coming soon"
          >
            <span
              className="allowlist-icon"
              aria-hidden="true"
              style={{
                position: "absolute",
                opacity: hoveredCaptains ? 0 : 0.9,
                transition: "opacity 0.7s ease",
                pointerEvents: "none",
              }}
            >
              <img className="icon-img" src={teamPng} alt="Captains" />
            </span>
            <span
              className="lock-icon"
              aria-hidden="true"
              style={{
                position: "relative",
                opacity: hoveredCaptains ? 0.9 : 0,
                transition: "opacity 0.7s ease",
                pointerEvents: "none",
              }}
            >
              <img className="icon-img" src={lockPng} alt="" />
            </span>
            <span className="icon-button-label">CAPTAINS</span>
          </button> */}
        </div>

        <div className="header-center">
          <a
            href="https://fortunefoes.com/"
            target="_blank"
            rel="noreferrer"
            className="header-center-star"
          >
            <img
              src={starLogo}
              alt="Fortune Foes"
              className="header-logo-star"
            />
          </a>
          <div className="center-content">
            <a href="https://fortunefoes.com/" target="_blank" rel="noreferrer">
              <img
                src={logo}
                alt="Fortune Foes"
                className="header-logo"
              />
            </a>
            <div className="choose-your-cult">
              <img
                src={ethLogoMedium}
                alt=""
                className="choose-your-cult__eth-icon"
                aria-hidden="true"
              />
              <span className="choose-your-side-label">NFT PNL LEAGUE</span>
            </div>
          </div>
        </div>

        <div className="header-right">
          <button
            type="button"
            className="icon-button-right"
            onClick={() => setIsSoundEnabled((v) => !v)}
            aria-label="Toggle sound"
          >
            {isSoundEnabled ? (
              <img src={musicOnPng} alt="Music On" />
            ) : (
              <img src={musicOffPng} alt="Music Off" />
            )}
          </button>

          <span className="header-divider" aria-hidden="true" />

          {!isConnected && !userInfo.isLogin ? (
            <div
              onClick={handleConnectWallet}
              className="connect-wallet-btn icon-button-right"
            >
              <img src={walletPng} alt="" aria-hidden="true" />
              <span>CONNECT</span>
            </div>
          ) : (
            <div onClick={handleLogout} className="connect-wallet-btn">
              <span className="user">
                {truncateWallet(
                  address || localStorage.getItem("address"),
                  12,
                )}
              </span>
              <span className="logout">LOG OUT</span>
            </div>
          )}
        </div>
      </header>

      <div className="choose-your-cult--mobile">
        <img
          src={ethLogoMedium}
          alt=""
          className="choose-your-cult__eth-icon"
          aria-hidden="true"
        />
        <span className="choose-your-side-label">NFT PNL LEAGUE</span>
      </div>

      {/* <div className="u-design hidden" aria-hidden="true">
        <div className="u-design-inner">
          <div className="u-design-hairline" />
        </div>
      </div> */}

      {showStarterInfo ? (
        <StarterInfoModal onClose={closeStarterInfo} />
      ) : null}
    </div>
  );
};

export default NavBar2;
